module.exports = __webpack_public_path__ + "static/media/sherbimservis.7b9ee4e0.jpg";